module.exports = __webpack_public_path__ + "static/media/gallery-15.c26552a3.jpeg";